import { HttpResponse } from "../types";
import HttpClientRequest from "../api/client-request";

export default class PaymentService {

    static async verifyPayment(txRef: string, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doGetRequest(`/payment/verify/${txRef}`, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error verifying payment:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }
}